import React from "react";

const Home = React.lazy(() => import("./components/pages/home/Home"));
const Skills = React.lazy(() => import("./components/pages/skills/Skills"));
const Contact = React.lazy(() => import("./components/pages/contact/Contact"));
const Projects = React.lazy(() =>
  import("./components/pages/projects/Projects")
);
const LegalNotice = React.lazy(() =>
  import("./components/DefaultLayout/footer/LegalNotice")
);

const routes = [
  {
    path: "/",
    exact: true,
    name: "Home",
    roules: ["admin", "manager", "user"],
  },
  {
    path: "/home",
    exact: true,
    index: true,
    name: "home",
    element: Home,
    roules: ["admin", "manager", "user"],
  },
  {
    path: "/skills",
    exact: true,
    index: true,
    name: "skills",
    element: Skills,
    roules: ["admin", "manager", "user"],
  },
  {
    path: "/projects",
    exact: true,
    index: true,
    name: "projects",
    element: Projects,
    roules: ["admin", "manager", "user"],
  },
  {
    path: "/contact",
    exact: true,
    index: true,
    name: "contact",
    element: Contact,
    roules: ["admin", "manager", "user"],
  },
  {
    path: "/legalnotice",
    exact: true,
    index: true,
    name: "legalnotice",
    element: LegalNotice,
    roules: ["admin", "manager", "user"],
  },
];

export default routes;
